import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { Media } from "api";

/* eslint-disable */
/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
function humanFileSize(bytes, si = true, dp = 1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

  return bytes.toFixed(dp) + " " + units[u];
}
/* eslint-enable */

async function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }

  try {
    await navigator.clipboard.writeText(text);
    console.log("Text copied to clipboard");
  } catch (err) {
    console.error("Failed to copy text: ", err);
  }
}

function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    const msg = successful ? "successful" : "unsuccessful";
    console.log("Fallback: Copying text command was " + msg);
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
  }

  document.body.removeChild(textArea);
}

function MediaLibrary({mode}) {
  const { t } = useTranslation();
  const history = useHistory();
  const [images, setImages] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { results },
        } = await Media.getAll({ pageSize: 1000 });
        setImages(results);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("Media Library")}</title>
      </Helmet>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox my={1.5}>
          <Grid container>
            <Grid item xs={12}>
              <Card>                
                <SuiBox p={3}>
                  <SuiBox pb={2}>
                  {mode!=="view" && (
                    <SuiButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        history.push("/media-library/upload");
                      }}
                    >
                      {t("ADD IMAGE")}
                    </SuiButton>
                    )}
                  </SuiBox>
                  <Divider />
                  <SuiBox>
                    <Grid container>
                      {images.map((img) => (
                        <Grid item xs={12} md={6} lg={3} mb={3} pr={3}>
                          <Card>
                            <SuiBox p={3}>
                              <SuiBox display="flex" alignItems="center" width="100%" mb={3}>
                                <img
                                  alt=""
                                  src={img.s3ObjKey.Location}
                                  style={{
                                    maxWidth: "100%",
                                    borderRadius: "15px",
                                  }}
                                />
                              </SuiBox>
                              <SuiBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <SuiBox display="flex" flexDirection="column" lineHeight={0}>
                                  <SuiTypography variant="button" fontWeight="medium">
                                    {img.fileName} ({img.id})
                                  </SuiTypography>
                                  <SuiTypography
                                    variant="button"
                                    fontWeight="medium"
                                    color="secondary"
                                  >
                                    {humanFileSize(img.size)}
                                  </SuiTypography>
                                </SuiBox>
                                <SuiBox display="flex" flexDirection="column" lineHeight={0}>
                                  <SuiButton
                                    variant="gradient"
                                    color="info"
                                    onClick={() => {
                                      copyTextToClipboard(img.s3ObjKey.Location);
                                    }}
                                  >
                                    {t("COPY LINK")}
                                  </SuiButton>
                                </SuiBox>
                              </SuiBox>
                            </SuiBox>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </SuiBox>
                </SuiBox>
              </Card>
            </Grid>
          </Grid>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default MediaLibrary;
